module.exports = __webpack_public_path__ + "img/Goal_8.733033cd.png";